import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Intro from './Intro';
import Map from './Map';
import './Home.css';

const API_BASE = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : '/api';

const START_TOKEN = '<start_time>';
const END_TOKEN = '<end_time>';

type Span = { start: string; end: string };

const formatSpanDate = (iso: string): string => {
  const [year, month] = iso.split('-').map(Number);
  if (!year || !month) {
    return iso;
  }
  return new Date(Date.UTC(year, month - 1, 1)).toLocaleString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

function Home() {
  const [params] = useSearchParams();
  const dev = params.get('dev') === '1';
  const [span, setSpan] = useState<Span | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/hexagons/time-span`)
      .then(async (response) => {
        if (!response.ok) {
          return null;
        }
        const body = await response.json() as Span;
        if (typeof body.start !== 'string' || typeof body.end !== 'string') {
          return null;
        }
        return body;
      })
      .then((body) => {
        if (!cancelled) {
          setSpan(body);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setSpan(null);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (span === undefined) {
    return null;
  }

  if (span === null && !dev) {
    return (
      <p className="home-blocked">
        The hex files may not be synchronized. Rebuild them together with
        python -m python.hex_maker.build_layers, or open this page with ?dev=1.
      </p>
    );
  }

  const start = span ? formatSpanDate(span.start) : START_TOKEN;
  const end = span ? formatSpanDate(span.end) : END_TOKEN;

  return (
    <div className="home">
      <Intro start={start} end={end} />
      <Map />
    </div>
  );
}

export default Home;
